class ShareButton extends DetailsDisclosure {
  constructor() {
    super();
    this.elements = {
      shareButton: this.querySelector('button'),
      shareSummary: this.querySelector('summary'),
      closeButton: this.querySelector('.share-button__close'),
      successMessage: this.querySelector('[id^="ShareMessage"]'),
      urlInput: this.querySelector('input'),
    };
    this.urlToShare = this.elements.urlInput ? this.elements.urlInput.value : document.location.href;
    
    this.init();
  }

  init() {
    if (navigator.share) {
      this.mainDetailsToggle.setAttribute('hidden', '');
      if (this.elements.shareButton) {
        this.elements.shareButton.classList.remove('hidden');
        this.elements.shareButton.addEventListener('click', this.onShareClick.bind(this));
      }
    } else {
      this.mainDetailsToggle.addEventListener('toggle', this.toggleDetails.bind(this));
      const copyBtn = this.querySelector('.share-button__copy');
      const closeBtn = this.querySelector('.share-button__close');
      if (copyBtn) copyBtn.addEventListener('click', this.copyToClipboard.bind(this));
      if (closeBtn) closeBtn.addEventListener('click', this.close.bind(this));
    }
  }

  onShareClick() {
    navigator.share({ 
      url: this.urlToShare, 
      title: document.title 
    }).catch(console.error);
  }

  toggleDetails() {
    if (!this.mainDetailsToggle.open) {
      this.resetMessage();
      this.elements.shareSummary.focus();
    }
  }

  copyToClipboard() {
    navigator.clipboard.writeText(this.elements.urlInput.value).then(() => {
      this.showSuccess();
    }).catch(() => {
      this.elements.urlInput.select();
      document.execCommand('copy');
      this.showSuccess();
    });
  }

  showSuccess() {
    this.elements.successMessage.classList.remove('hidden');
    this.elements.successMessage.textContent = window.accessibilityStrings?.shareSuccess || 'Link copied to clipboard';
    this.elements.closeButton.classList.remove('hidden');
    this.elements.closeButton.focus();
  }

  resetMessage() {
    this.elements.successMessage.classList.add('hidden');
    this.elements.successMessage.textContent = '';
    this.elements.closeButton.classList.add('hidden');
  }

  close() {
    this.mainDetailsToggle.open = false;
  }

  updateUrl(url) {
    this.urlToShare = url;
    if (this.elements.urlInput) this.elements.urlInput.value = url;
  }
}

if (!customElements.get('share-button')) {
  customElements.define('share-button', ShareButton);
}
